var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "header"
  }, [_c('h4', [_vm._v("Education Posts")]), _c('div', {
    staticClass: "buttons"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini",
      "icon": "el-icon-plus",
      "round": "",
      "loading": _vm.loadingNew
    },
    on: {
      "click": _vm.create
    }
  }, [_vm._v("New")])], 1)]), _c('Table', {
    attrs: {
      "items": _vm.educationPosts,
      "columns": _vm.columns,
      "actions": _vm.actions,
      "loading": _vm.loading.announcements
    }
  }), _c('EditDialog', {
    attrs: {
      "item": _vm.item,
      "isOpen": _vm.showEditDialog,
      "onClose": function () {
        return _vm.showEditDialog = false;
      },
      "fields": _vm.fields
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }